import axiosInstance from "./authentication/axiosInstance";

const BASE_URL = "/assistance-teams";

export const assistanceTeamServices = {

    postAssistanceTeamData: async (newPost) => {
        const response = await axiosInstance.post(BASE_URL, newPost);
        return response.data;
    },

    updateAssistanceTeamData: async (updatePost) => {
        const response = await axiosInstance.put(BASE_URL, updatePost);
        return response.data;
    },

    getAllAssistanceTeams: async (search, page, size, sortField = 'id', sortDir = 'desc') => {
        const response = await axiosInstance.get(`${BASE_URL}?search=${search || ''}&pageNo=${page}&size=${size}&sortField=${sortField}&sortDir=${sortDir}`);
        return response.data;
    },

    getAllAssistanceTeamsList: async () => {
        const response = await axiosInstance.get(`${BASE_URL}/all`);
        return response.data;
    },

    getAssistanceTeamsByParentTeam: async (parentTeamId) => {
        const response = await axiosInstance.get(`${BASE_URL}/byParent/${parentTeamId}`);
        return response.data;
    },

    deleteAssistanceTeamData: async (assistanceTeamId) => {
        const response = await axiosInstance.delete(`${BASE_URL}/${assistanceTeamId}`);
        return response.data;
    },

    addMemberUserToAssistanceTeam: async (formData) => {
        const response = await axiosInstance.post(`${BASE_URL}/addTeamMember`, formData);
        return response.data;
    },

    removeMemberFromAssistanceTeam: async (userId) => {
        const response = await axiosInstance.delete(`${BASE_URL}/member/${userId}`);
        return response.data;
    },

    getEligibleLeads: async (parentTeamId) => {
        const response = await axiosInstance.get(`${BASE_URL}/eligible-leads/${parentTeamId}`);
        return response.data;
    },

    getEligibleMembers: async (parentTeamId, assistanceTeamId) => {
        const url = assistanceTeamId 
            ? `${BASE_URL}/eligible-members?parentTeamId=${parentTeamId}&assistanceTeamId=${assistanceTeamId}`
            : `${BASE_URL}/eligible-members?parentTeamId=${parentTeamId}`;
        const response = await axiosInstance.get(url);
        return response.data;
    },

    getAssistanceTeamMembers: async (assistanceTeamId) => {
        const response = await axiosInstance.get(`${BASE_URL}/members/${assistanceTeamId}`);
        return response.data;
    },
};
